<template>
  <div>
    <v-alert
      prominent
      color="red"
      type="error"
      border="top"
      v-if="error.active"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ error.text }}
        </v-col>
      </v-row>
    </v-alert>
    <v-row>
      <v-col cols="8" sm="8" md="8" lg="8">
        <v-btn-toggle v-model="type" color="primary" mandatory tile>
          <v-btn text value="file">
            {{ $t("components.selectors.multilingualDocumentSelector.file") }}
          </v-btn>
          <v-btn text value="link">
            {{ $t("components.selectors.multilingualDocumentSelector.link") }}
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="4" sm="4" md="4" lg="4">
        <v-btn
          color="primary"
          class="float-right"
          @click="type === 'file' ? setFile() : setLink()"
          text
          >{{
            $t("components.selectors.multilingualDocumentSelector.addResource")
          }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" sm="8" md="8" lg="8" class="pt-0">
        <v-form ref="form" v-model="view.isValid" lazy-validation>
          <direct-file-upload
            v-show="type === 'file'"
            :multiple="false"
            :rules="rules.file"
            :loading.sync="view.isLoading"
            accepted-formats="image/*,.pdf"
            asset-type="document_asset"
            ref="directFileUpload"
            :label="
              $t('components.selectors.multilingualDocumentSelector.fileInput')
            "
            :hint="
              $t('components.selectors.multilingualDocumentSelector.required')
            "
            prepend-icon="mdi-file"
            :persistentHint="true"
            :disablePreview="true"
            @updateFile="file = $event"
          ></direct-file-upload>
          <!-- @updateFiles="setFile" -->

          <v-text-field
            v-show="type === 'link'"
            color="primary"
            v-model="link"
            :rules="rules.url"
            :label="
              $t('components.selectors.multilingualDocumentSelector.linkInput')
            "
            :hint="
              $t('components.selectors.multilingualDocumentSelector.required')
            "
            persistent-hint
            prepend-icon="mdi-link"
          ></v-text-field>
        </v-form>
      </v-col>

      <v-col cols="4" sm="4" md="4" lg="4" class="pt-0">
        <v-select
          multiple
          color="primary"
          :rules="rules.languageSelector"
          persistent-hint
          :hint="
            $t('components.selectors.multilingualDocumentSelector.required')
          "
          v-model="languageSelector"
          :items="languageOptions"
          item-value="id"
          item-text="title"
          :label="
            $t(
              'components.selectors.multilingualDocumentSelector.selectLanguage'
            )
          "
        ></v-select>
        <!-- prepend-icon="mdi-translate" -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-list
          subheader
          v-for="(attachment, index) in attachments"
          :key="index"
          class="pt-0 pb-0"
        >
          <v-list-item class="pt-0 pb-0 pr-0 pl-8">
            <v-list-item-content>
              <v-list-item-title>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <span>
                        <v-icon class="mr-2">{{
                          getAttachmentIcon(
                            attachment.internalType,
                            attachment.type
                          )
                        }}</v-icon>
                        {{
                          truncateAttachmentName(
                            attachment.title || attachment.name
                          )
                        }}</span
                      >
                    </span>
                  </template>
                  <span>{{ attachment.title || attachment.name }}</span>
                </v-tooltip>
                <v-chip outlined class="ml-2"
                  >{{ attachment.internalType === "file" ? "File" : "Link" }}
                </v-chip>
                <v-chip
                  outlined
                  class="ml-1 float-right"
                  v-for="(language, index) in attachment.languages"
                  :key="index"
                >
                  {{ getAvailableLanguage(language) }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon @click="removeAttachment(index)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DirectFileUpload from "@/components/miscellaneous/DirectFileUpload.vue";
import snackbar from "@/utils/snackbar.js";
export default {
  components: {
    DirectFileUpload,
  },
  props: {
    attachments: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      file: [],
      link: "",
      type: "file",
      view: { isLoading: false, isValid: true },
      error: {
        active: false,
        text: "",
      },
      rules: {
        file: [],
        url: [],
      },
      languageOptions: [],
      languageSelector: [],
    };
  },
  created() {
    this.setIntialData();
  },
  watch: {
    attachments(newValue, oldValue) {
      if (this.error.active && newValue.length !== 0) {
        this.error.active = false;
      }
    },
  },
  methods: {
    setIntialData() {
      this.languageOptions = [
        {
          id: "unknown",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.unknown"
          ),
        },
        {
          id: "en",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.english"
          ),
        },
        {
          id: "de",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.german"
          ),
        },
        {
          id: "fr",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.french"
          ),
        },
        {
          id: "it",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.italian"
          ),
        },
        {
          id: "es",
          title: this.$t(
            "components.selectors.multilingualDocumentSelector.spanish"
          ),
        },
      ];

      this.languageSelector = [
        this.languageOptions.find((item) => {
          return item.id === "unknown";
        }).id,
      ];

      this.rules.file = [
        (v) =>
          !!v ||
          this.$t(
            "components.selectors.multilingualDocumentSelector.fileIsRequired"
          ),
      ];
      this.rules.url = [
        (v) =>
          !!v ||
          this.$t(
            "components.selectors.multilingualDocumentSelector.linkIsRequired"
          ),
        (v) =>
          /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(
            v
          ) ||
          this.$t(
            "components.selectors.multilingualDocumentSelector.urlMustBeValid"
          ),
      ];

      this.rules.languageSelector = [
        (v) =>
          !!v ||
          this.$t(
            "components.selectors.multilingualDocumentSelector.fileIsRequired"
          ),
      ];
    },
    setFile() {
      if (this.file.length === 0) return;

      this.file.internalType = "file";
      this.file.languages = this.languageSelector;
      this.file.dirty = true;

      this.attachments.push(this.file);
      this.$emit("update:attachments", this.attachments);
      this.clearInputs(true);
    },
    setLink() {
      if (this.link.length === 0) return;

      const link = {
        internalType: "link",
        url: this.link,
        languages: this.languageSelector,
        name: this.link,
        dirty: true,
      };

      this.attachments.push(link);
      this.$emit("update:attachments", this.attachments);
      this.clearInputs(false);
    },
    clearInputs(callFromSetFile = false) {
      this.file = [];
      this.link = "";
      this.languageSelector = [
        this.languageOptions.find((item) => {
          return item.id === "en";
        }).id,
      ];

      if (callFromSetFile) {
        this.$refs.directFileUpload.removeAll();
      }
    },

    truncateAttachmentName(name) {
      if (name.length > 20) return name.slice(0, 20) + "...";

      return name;
    },

    getAvailableLanguage(language) {
      const languageObject = this.languageOptions.find((item) => {
        return item.id === language;
      });
      if (typeof languageObject === "undefined") return null;
      return languageObject.title;
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
      this.$emit("update:attachments", this.attachments);
    },
    checkNumberOfAttachments() {
      //HACK: This function is called from outside of this component
      if (this.attachments.length === 0) {
        this.error.active = true;
        this.error.text = this.$t(
          "components.selectors.multilingualDocumentSelector.pleaseAddAtLeastOneResource"
        );
      }
    },
    addAttachmentIfExists() {
      //CHECK: this statement is here to check if user forgot to add attachment with button (not best UI/UX for adding one attachment)
      this.type === "link" ? this.setLink() : this.setFile();
    },
    getAttachmentIcon(type, extension) {
      if (type === "link") {
        return "mdi-link";
      }

      if (
        /(gif|jpe?g|tiff?|png|webp|bmp|svg)$/i.test(extension) &&
        type === "file"
      ) {
        return "mdi-file-image";
      }

      return "mdi-file-document";
    },
    save(categories, groupUuid) {
      //HACK: This function is called from outside of this component
      let self = this;
      return new Promise((resolve, reject) => {
        const attachmentsToBeAdded = this.attachments.filter((item) => {
          return item.dirty;
        });

        const alreadyAddedFiles = this.attachments
          .filter((item) => {
            return typeof item.uuid !== "undefined";
          })
          .map((item) => {
            return item.uuid;
          });

        const files = attachmentsToBeAdded.filter((item) => {
          return item.internalType === "file";
        });

        // WARNING: can't use map HOF because we deal with File structure and not with Object or Array
        files.forEach((element) => {
          element.categories = categories;
          element.group_uuid = groupUuid;
        });

        const links = attachmentsToBeAdded
          .filter((item) => {
            return item.internalType === "link";
          })
          .map((item) => {
            return {
              languages: item.languages,
              url: item.url,
            };
          });

        if (files.length !== 0) {
          this.$refs.directFileUpload
            .save(files)
            .then((items) => {
              resolve({
                files: [...new Set([...items.fileUuids])],
                links: links,
                alreadyAddedFiles: alreadyAddedFiles,
              });
            })
            .catch((err) => {
              reject(err);
            });
        } else if (links.length !== 0) {
          resolve({
            files: [],
            links: links,
            alreadyAddedFiles: alreadyAddedFiles,
          });
        } else {
          resolve({
            files: [],
            links: [],
            alreadyAddedFiles: alreadyAddedFiles,
          });
          // this.error.active = true;
          // this.error.text = this.$t(
          //   "components.selectors.multilingualDocumentSelector.pleaseAddAtLeastOneResource"
          // );
          // console.error("DOCUMENTS: No files and links added");
        }
      });
    },
  },
};
</script>
<style lang=""></style>
